// 「業務で使用している生成AIツール」の選択肢（複数選択）
export const AI_TOOL_OPTIONS: { label: string; value: string }[] = [
  { label: 'ChatGPT', value: 'ChatGPT' },
  { label: 'Gemini', value: 'Gemini' },
  { label: 'Claude', value: 'Claude' },
  { label: 'Microsoft Copilot', value: 'Microsoft Copilot' },
  { label: 'Perplexity', value: 'Perplexity' },
  {
    label: 'GitHub Copilot / Codex / Cursor などの開発支援AI',
    value: 'GitHub Copilot / Codex / Cursor などの開発支援AI'
  },
  {
    label: 'Notion AI / Slack AI などの業務アプリ内AI',
    value: 'Notion AI / Slack AI などの業務アプリ内AI'
  },
  {
    label: '自社・社内独自の生成AIツール',
    value: '自社・社内独自の生成AIツール'
  },
  { label: 'その他', value: 'その他' },
  { label: '使用していない', value: '使用していない' }
]

// Salesforce 側の項目 API 名（Lead / Contact の Generative_ai_tools_used_for_work__c）
const AI_TOOLS_FIELD_KEY = 'Generative_ai_tools_used_for_work'

// Salesforce の複数選択リストに合わせてセミコロン区切りへ変換する
const joinAiTools = (values: string[] = []) => values.join(';')

// フォームの ai_tools（配列）を Salesforce 連携用のキー・形式に置き換える
export const toAiToolsPayload = <T extends { ai_tools?: string[] }>(
  data: T
) => {
  const rest: Record<string, unknown> = { ...data }
  delete rest.ai_tools
  return { ...rest, [AI_TOOLS_FIELD_KEY]: joinAiTools(data.ai_tools) }
}
